import { PremadeTripType } from '../../models';
import type {
  SanityPremadeTrip,
  SanityPublishedTripDetailsResponse,
} from '../../models';

export function mapDomainLocaleToSanityLang(lang: string): string {
  function capitalizeFirstLetter(s: string): string {
    return `${s.charAt(0).toUpperCase()}${s.slice(1)}`;
  }

  // NOTE: Content in Sanity uses different locale mapping than fe-libs for Danish market.
  // This might be true for other markets aswell. Check Sanity Studio for more details.
  if (lang === 'dk') {
    return 'Da';
  }
  return capitalizeFirstLetter(lang);
}

export function mapFullLocaleToSanityCountry(fullLocale: string): string {
  const fullLocaleArray = fullLocale.split('-');
  const country = fullLocaleArray[1];

  if (!country) {
    throw new Error('Cannot split full locale into locale and country!');
  }

  return country;
}

export function mapResponseToPublishedTrip(
  response: SanityPublishedTripDetailsResponse
): SanityPremadeTrip | undefined {
  const imageWidthLimitPx = 800;
  const imageUrl = `${response.imgUrl}?w=${imageWidthLimitPx}`;

  return {
    type: PremadeTripType.PublishedInSanity,
    headline: response.headline,
    description: [...response.salesPitch, ...response.description],
    imageUrl,
  };
}
